import(/* webpackMode: "eager" */ "/vercel/path0/apps/admin/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConvexClientProvider"] */ "/vercel/path0/apps/admin/providers/convex-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConvexAuthNextjsClientProvider"] */ "/vercel/path0/node_modules/@convex-dev/auth/dist/nextjs/client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/packages/ui/src/components/toaster.tsx");
